import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CallingMadeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallingMade",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.83 15.62c.14.39.31.78.51 1.18 1.23 2.5 2.8 4.64 4.67 6.46 1.83 1.87 3.97 3.42 6.33 4.58l.14.06c.72.35 1.57.68 2.45.92l.11.03c2.66.72 5.05.44 6.5-1.02l1.35-1.37c.36-.35.57-.84.57-1.38s-.22-1.03-.57-1.38l-3.67-3.64c-.35-.35-.83-.57-1.37-.57s-1.02.22-1.37.57l-2.66 2.66c-.23.23-.56.38-.91.38s-.68-.14-.91-.38l-5.51-5.46c-.24-.23-.38-.56-.38-.91s.15-.68.38-.91l2.66-2.66c.35-.35.57-.83.57-1.37s-.22-1.02-.57-1.37L7.52 6.36c-.35-.35-.83-.57-1.37-.57s-1.02.22-1.37.57L3.41 7.72c-1.71 1.71-1.8 4.66-.58 7.9M28.18 3.08l-7.24 7.24-2.98-2.98c-.19-.19-.46-.31-.76-.31-.59 0-1.07.48-1.07 1.07 0 .29.12.56.31.76l3.73 3.73a1.09 1.09 0 0 0 1.52 0l7.99-7.99a1.09 1.09 0 0 0 0-1.52 1.09 1.09 0 0 0-1.52 0Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M20.86 28c-1.83 0-3.65-.7-5.05-2.09l-9.73-9.73a7.1 7.1 0 0 1-1.27-8.36c.26-.49.86-.68 1.35-.42s.68.86.42 1.35c-1.05 2-.68 4.42.92 6.02l9.73 9.73c2 2 5.26 2 7.26 0l1.09-1.09-3.73-3.73a3.046 3.046 0 0 1-4.2-.1l-5.26-5.26a3 3 0 0 1-.89-2.15c0-.76.28-1.48.79-2.04L7.88 5.72a.996.996 0 1 1 1.41-1.41l5.11 5.11c.19.19.29.44.29.71s-.11.52-.29.71l-.6.6a1.037 1.037 0 0 0 0 1.48l5.26 5.26c.4.4 1.03.41 1.44.03l.69-.63c.39-.36 1-.35 1.38.03l5.11 5.11c.39.39.39 1.02 0 1.41l-1.8 1.8a7.13 7.13 0 0 1-5.05 2.09ZM22.67 11.33c-.27 0-.52-.11-.71-.29l-2.67-2.67a.996.996 0 1 1 1.41-1.41l1.96 1.96 4.63-4.63A.996.996 0 1 1 28.7 5.7l-5.33 5.33a1 1 0 0 1-.71.29Z"
      })
    })
  }));
};